export const PARTICIPANTS_ROLES = {
  OWNER: 'ROLE_OWNER',
  SIGNER: 'DOCUMENT_SIGNER',
  APPROVER: 'DOCUMENT_APPROVER',
  VIEWER: 'DOCUMENT_VIEWER',
  FILLER: 'DOCUMENT_FILLER'
}

export const participantRolesUkMap = {
  ROLE_OWNER: 'Власник',
  DOCUMENT_SIGNER: 'Підписант',
  DOCUMENT_APPROVER: 'Погоджувач',
  DOCUMENT_VIEWER: 'Переглядач',
  DOCUMENT_FILLER: 'Заповнювач'
}

export const participantStatusesUkMap = {
  created: 'Створено',
  pending: 'Очікується дія',
  signed: 'Підписано',
  viewed: 'Переглянуто',
  filled: 'Заповнено',
  approved: 'Погоджено',
  rejected: 'Відхилено',
  cancelled: 'Анульовано'
}
